import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Back",
	updateManyExternalIntegrations: {
		success: "Integrations updated successfully",
	},
	externalStoreIntegrationStatus: {
		synced: "Synced",
		pendingSyncing: "Syncing pending",
		pendingImporting: "Importing pending",
	},
	ordersManager: {
		title: "Orders Manager",
		description:
			"Track and manage orders that come from Entregue já, Comanda Online and Pedido na mesa.",
		filter: {
			placeholder: "Filter by",
			orderStatus: "Order Status",
			paymentMethod: "Payment Method",
			orderOrigin: "Order Origin",
			appliedFilters: "filter(s) applied",
		},
		tabs: {
			newOrders: "New Orders",
			completed: "Completed",
		},
		loading: "Loading",
		total: "Total: {{value}}",
		new: "New",
		emptyState: {
			title: "We don't have any {{status}} orders yet.",
			description: "We'll show you here when you receive new orders.",
		},
	},
	orderStatuses: {
		placed: "Pending",
		confirmed: "Accepted",
		dispatched: "In delivery",
		concluded: "Completed",
		cancelled: "Cancelled",
		pendingPayment: "Pending payment",
		ready: "Ready",
		pickupAreaAssigned: "Customer at location",
		scheduled: "Scheduled",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
